import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faClose, faHome } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../services/authentication/authentication.context";
import { formatUrl } from "../../helpers/parse-url";


import "../../styles/note-header.css";


export const BmsHeader = () => {

    const [vNav, setvNav] = useState(false);

    const navigateTo = useNavigate();

    const { isAuthenticated, userData, logoutUser, token, googleAccountLogout } = useAuth();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    },[])

    return (
        <header className='note-header'>
            <div className='header-container'>
                <img className='app-logo' src='/media/notebook-logo.png' alt='' />
                <span className='app-name'>NoteBook BMS</span>
                <button
                    className='bar-close'
                    onClick={() => {
                        setvNav((v) => !v)
                    }}
                >
                    <FontAwesomeIcon icon={
                        vNav ? faClose : faBars
                    } />
                </button>

                <div
                    className={
                        classNames(
                            'note-nav',
                            { "sliding-nav": vNav }
                        )}
                >
                    <div className="extra" onClick={() => navigateTo("/")}>
                        <button className="auth-button">
                            <span style={{marginInline: 8}}>Home</span>
                            <FontAwesomeIcon icon={faHome} />
                        </button>
                    </div>
                    <button
                        className='note-nav-button'
                        onClick={() => navigateTo("/lecture_notes")}
                    >
                        Lecture notes
                    </button>
                    <button
                        className='note-nav-button'
                        onClick={() => navigateTo("/tutorials")}
                    >
                        Tutorials
                    </button>
                    <button
                        className='note-nav-button'
                        onClick={() => navigateTo("/pastquestions")}
                    >
                        HND Past Q/A
                    </button>
                    <button
                        className='note-nav-button'
                        onClick={() => navigateTo("/globalmedic")}
                    >
                        Global Medic
                    </button>
                    {isAuthenticated ?
                        <button
                            className='auth-button'
                            onClick={() => {
                                if (userData?.authMethod === "Google") {
                                    logoutUser(token);
                                    googleAccountLogout();
                                } else logoutUser(token);
                            }}
                        >
                            logout
                        </button> :
                        <button
                            className='auth-button'
                            onClick={() => navigateTo("/login")}
                        >
                            sign in
                        </button>

                    }
                    {!isAuthenticated ?
                        <button
                            className='auth-button'
                            onClick={() => navigateTo("/register")}
                        >
                            register
                        </button> :
                        <button
                            className="user-avatar-box"
                            onClick={() => navigateTo("/myprofile")}
                        >
                            <img
                                src={formatUrl(userData?.avatar)}
                                className="user-img"
                                alt=""
                            />
                        </button>
                    }

                </div>
            </div>

        </header>
    )
}